import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { dataType } from "../dataType";
import { AuthService } from "../auth.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ForgotPasswordModalComponent } from "../forgot-password-modal/forgot-password-modal.component";
import { ToastrManager } from "ng6-toastr-notifications";
import { NewPasswordChallangeComponent } from "../new-password-challange/new-password-challange.component";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  public user;
  public show: boolean;
  constructor(
    private router: Router,
    private auth: AuthService,
    private modalService: NgbModal,
    private toastr: ToastrManager,
    private spinner: NgxSpinnerService
  ) {
    this.user = this.checkDefaultUser(localStorage.getItem("username"));
 
    if (localStorage.getItem("loggedIn") == "true") {
      this.router.navigate(["/dashboard"]);
    }
    console.log("login");
  }

  forgotPwd() {
    this.modalService.open(ForgotPasswordModalComponent);
  }

  ngOnInit() {
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.spinner.hide();
      this.show = true
  }, 2000);
  }

  checkDefaultUser(user) {
    return user != undefined
      ? {
          userName: localStorage.getItem("username"),
          password: localStorage.getItem("password"),
          remember: true
        }
      : { userName: "", password: "", remember: false };
  }

  userLogin(user) {
    this.spinner.show();

    console.log(user);
    localStorage.setItem("newUser", user.userName);

    if (user.remember == true) {
      localStorage.setItem("username", user.userName);
      localStorage.setItem("password", user.password);
    } else {
      if (user.userName == localStorage.getItem("username")) {
        localStorage.removeItem("username");
        localStorage.removeItem("password");
      }
    }

    this.auth.userLogin(user).subscribe((res: any) => {
      console.log(res);

      if (res.Status == "Success") {
        localStorage.setItem(
          "pic",
          res.Data.signInUserSession.idToken.payload.picture
        );
        localStorage.setItem(
          "userName",
          res.Data.signInUserSession.accessToken.payload.username
        );

        this.spinner.hide();
        this.toastr.successToastr('Access Granted..!!','success');
        this.auth.setLoggedIn(true, res.Data.signInUserSession);
        this.router.navigate(["/dashboard"]);
      } else {
        this.spinner.hide();
        if (res.Error == "NEW_PASSWORD_REQUIRED") {
          this.modalService.open(NewPasswordChallangeComponent);
        } else {
          this.toastr.errorToastr(res.Error.message,'error');
        }
      }

      this.user = this.checkDefaultUser(undefined);
    });
  }
}
